import hasFeature from 'modules/core/lib/hasFeature'

//TODO: Uncomment for second phase.
// const INHOUSE_PAYROLL_PLAN_FAMILIES = [
//   'finance_hub_business',
//   'finance_hub_enterprise',
//   'finance_hub_base_business',
//   'finance_hub_base_enterprise',
//   'operations_hub_business',
//   'operations_hub_enterprise',
//   'operations_hub_shift_management_business',
//   'operations_hub_shift_management_enterprise',
//   'factorial_suite_business',
//   'factorial_suite_enterprise',
//   'factorial_suite_base_business',
//   'factorial_suite_base_enterprise',
// ]
interface InhousePayroll {
  hasInhousePayroll: boolean
}

export const hasInHousePayroll = (): boolean => {
  return hasFeature('inhouse_payroll') && !hasFeature('factorial_professionals')
}

export const useInhousePayroll = (): InhousePayroll => {
  /**
   * TODO: We have decided to divde the release in two pashes.
   * In this first phase we are only granting access by FF.
   * The code commented below is ready for the second phase where we will grant access also by plan family.
   */
  // const currentSubscription = subscriptions.find({
  //   current: true,
  // })
  // const currentPlanFamily = currentSubscription?.attributes.plan_family
  const hasInhousePayroll = hasInHousePayroll()
  //  && INHOUSE_PAYROLL_PLAN_FAMILIES.includes(currentPlanFamily)

  return {
    hasInhousePayroll,
  }
}
